// extracted by mini-css-extract-plugin
export default {"container":"c96cn"};